import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography";

import Paper from "@mui/material/Paper";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import ButtonBase from '@mui/material/ButtonBase';

import { grey } from '@mui/material/colors';

import { Checkbox, Divider, Drawer } from "@mui/material";

import CloseIcon from '@mui/icons-material/Close';

// 送信先選択パート
function SelectDestinationPart({
  shops,
  setShops
}) {

  const handleChangeSelectingShop = (index) => (event) => {
    let newShops = [...shops];
    shops[index].isSelected = event.target.checked;
    setShops(newShops);    
  }

  return (
    <Box>       
      <Typography>送信対象店舗選択</Typography>
      <Box border="1px black solid" height="50vh" sx={{overflowY: "auto"}}>
        <TableContainer component={Paper} >
          <Table>
            <TableBody>
              {
                shops.map((shopData, i) => (
                  <TableRow key={`shop_${i}`}>
                    <TableCell padding="none" sx={{width:0}}>
                      <Checkbox
                        checked={shopData.isSelected}
                        onChange={handleChangeSelectingShop(i)}                        
                      />
                    </TableCell>
                    <TableCell padding="none" sx={{width:"60%"}}>
                      <Typography>{shopData.customerName}</Typography>
                    </TableCell>
                    <TableCell padding="none">
                      <Typography>{shopData.shopName}</Typography>
                    </TableCell>                      
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}

export function SelectDestinationDrawer ({open, onClose, params}) {

  return (
    <Drawer
      open={open}
      onClose={onClose}
      variant="persistent"
      anchor="right"
      PaperProps={{
        style: {
          position: "absolute"
        }
      }}
    >
      <Box padding={2} width="30vw">
        <ButtonBase onClick={onClose}>
          <Grid container>
            <Grid item xs="auto">
              <CloseIcon htmlColor={grey[600]} />
            </Grid>
            <Grid item  xs="auto">
              <Typography>閉じる</Typography>
            </Grid>              
          </Grid>            
        </ButtonBase>

        <Divider sx={{marginY: 1}}/>      

        <Box marginBottom={2}>
          <SelectDestinationPart
            shops={params.shops}
            setShops={params.setShops}
          />
        </Box>
      </Box>
    </Drawer>
  )
}
